import React from 'react'

interface Props {
	title: string
	text: string
	divider?: boolean
}

const DisplayInfo = (props: Props) => {
	const { title, text, divider } = props

	return (
		<div className={divider ? 'info-cell border-r border-[#e5e5e5]' : 'info-cell'}>
			<div className='title text-text-grey-200 dark:text-text-grey-100'>{title}</div>
			<div className='text text-text-dark dark:text-white'>{text}</div>
		</div>
	)
}

export default DisplayInfo
